import React, { useState } from 'react';
import styled from '@emotion/styled';
import {
    useHistory,
} from "react-router-dom";
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import InnerRoutes from './InnerRoutes';
import { clearApiToken, decodeToken, getApiToken } from './toolympus/api/core';
// import { SchemaProvider } from './toolympus/hooks/useSchema';
import { AppWrapper, Sidebar, Menu, Routes, getRoutesToRender, AppContentSimple, DrawerPaperView } from './toolympus/components/frame/new';
import { DefaultUser, LogoutSoonWarning, UserContext } from './toolympus/userContext/UserContext';
import { ExitToApp } from '@mui/icons-material';
import { useLoginGuard } from './toolympus/hooks/auth/useLoginGuard';
import { Logo } from './components/Common';
import { SubSelector } from './components/SubSelector';
import { DictionariesProvider } from './toolympus/hooks/useDictionaries';
import { ThemeSettings } from './theme';


const DrawerPaper = styled(DrawerPaperView)`
  & .MuiPaper-root {
    background: ${ThemeSettings.colors.black};
    color: ${ThemeSettings.colors.background};

    & .MuiSvgIcon-root {
      color: ${ThemeSettings.colors.background};
    }

    & .Mui-selected {
      color: ${ThemeSettings.colors.primary};
      & .MuiSvgIcon-root {
        color: ${ThemeSettings.colors.primary};
      }
    }
  }
`;;

const AppRouter: React.FC = () => {
    const token = getApiToken();
    const history = useHistory();
    const [user, setUser] = useState<DefaultUser>(token ? decodeToken(token) as DefaultUser : { _id: '', roles: [], email: '' });

    const logout = () => {
        clearApiToken();
        history.push('/login');
    }

    useLoginGuard("/login", { isAuthenticated: !!user && user.roles.length > 0 });

    const { routes, menuItems } = getRoutesToRender(InnerRoutes, user);

    const bottom = (
        <List>
            <SubSelector />
            <ListItem button key='logout' onClick={logout}>
              <ListItemIcon><ExitToApp /></ListItemIcon>
              <ListItemText primary='Sign out' />
            </ListItem>
        </List>
    )

    return (
        <UserContext.Provider value={{ user: user, setUser: setUser }}>
          <DictionariesProvider apiPath="/api/settings/dictionaries">
            <LogoutSoonWarning />
            {/* <SchemaProvider> */}
                        <AppWrapper>
                            <Sidebar
                                top={<Logo />}
                                menu={<Menu menuItems={menuItems} />}
                                bottom={bottom}
                                open={true}
                                onClose={() => { }}
                                drawerPaperProps={{ shadow: true }}
                                drawerPaperComponent={DrawerPaper}
                            />
                            <AppContentSimple fit100Height>
                                <Routes routes={routes} notFoundRedirect={user?.roles?.includes("admin") ? "/cms" : "/my-events"} />
                            </AppContentSimple>
                        </AppWrapper>
            {/* </SchemaProvider> */}
          </DictionariesProvider>
        </UserContext.Provider>
    );
}

export default AppRouter;

